(() => {
  const loaded = new Set(Array.from(document.scripts, script => script.src).filter(Boolean));
  function loadSection(section) {
    section.querySelectorAll('script[data-src]').forEach(placeholder => {
      const src = new URL(placeholder.dataset.src, document.baseURI).href;
      if (loaded.has(src)) return;
      loaded.add(src);
      const script = document.createElement('script');
      script.src = src;
      document.head.appendChild(script);
    });
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      loadSection(entry.target);
      observer.unobserve(entry.target);
    });
  }, {rootMargin: '300px 0px'}) : null;
  function watchSection(section) {
    if (!section.querySelector('script[data-src]')) return;
    if (observer) observer.observe(section);
    else loadSection(section);
  }
  document.querySelectorAll('.shopify-section').forEach(watchSection);
  document.addEventListener('shopify:section:load', event => watchSection(event.target));
})();
